module.exports = __webpack_public_path__ + "assets/home-ced5fd0fdb224df839f91118454901dd.svg";